// JsFromRoutes CacheKey f0234156201c9cacd5322fabd73e7c0c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/accounts'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/accounts'),
  new: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/accounts/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/accounts/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/accounts/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/api/workspace/:venue_slug/accounts/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/api/workspace/:venue_slug/accounts/:id'),
}
